<template>
  <section class="doctors-section">
    <div class="container">
      <div class="section-header">
        <h2 v-for="item in tips.title" :key="item">{{ item }}</h2>
        <p v-for="item in tips.description" :key="item">{{ item }}</p>
      </div>
      <div class="doctors-grid">
        <div class="doctor-card" v-for="doctor in info" :key="doctor.id">
          <img class="doctor-avatar" :src="doctor.avatar" :alt="doctor.name" />
          <h3>{{ doctor.name }}</h3>
          <p class="doctor-title">{{ doctor.title }}</p>
          <p class="doctor-specialty">{{ doctor.specialty }}</p>
          <div @click="switchToDoc(doctor.category)" class="btn-small">
            查看详情
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script setup lang="ts">
import { useRouter } from "vue-router";

export type DoctorsSectionProps = {
  id: number;
  name: string;
  title: string;
  specialty: string;
  avatar: string;
  category: string;
};
interface tipsProps {
  title: string[];
  description: string[];
}

interface SectionProps {
  info: DoctorsSectionProps[];
  tips: tipsProps;
}
withDefaults(defineProps<SectionProps>(), {});
const router = useRouter();

const switchToDoc = (dept: string) => {
  router.push({
    name: "Doctors",
    params: { dept },
  });
};
</script>

<style scoped>
/* 内容区域通用样式 */
.container {
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 20px;
}

.section-header {
  text-align: center;
  margin-bottom: 50px;
}

.section-header h2 {
  font-size: 2.5rem;
  color: #1a5fb4;
  margin-bottom: 15px;
}

.section-header p {
  font-size: 1.1rem;
  color: #666;
  max-width: 620px;
  margin: 0 auto;
}

/* 专家团队 */
.doctors-section {
  padding: 80px 0;
  background-color: #f8f9fa;
}

.doctors-grid {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 30px;
}

.doctor-card {
  background: white;
  padding: 30px;
  border-radius: 10px;
  text-align: center;
  box-shadow: 0 5px 15px rgba(0, 0, 0, 0.05);
  transition:
    transform 0.3s,
    box-shadow 0.3s;
}

.doctor-card:hover {
  transform: translateY(-5px);
  box-shadow: 0 10px 25px rgba(0, 0, 0, 0.1);
}

.doctor-avatar {
  width: 120px;
  height: 160px;
  object-fit: cover;
  object-position: center;
  margin-bottom: 20px;
  border-radius: 8px;
  margin: 0 auto;
}

.doctor-card h3 {
  margin-bottom: 10px;
  color: #333;
  font-size: 1.2rem;
}

.doctor-title {
  color: #1a5fb4;
  font-weight: 600;
  margin-bottom: 5px;
  font-size: 0.95rem;
}

.doctor-specialty {
  color: #666;
  margin-bottom: 20px;
  font-size: 0.9rem;
  line-height: 1.5;
}

.btn-small {
  padding: 8px 20px;
  font-size: 0.9rem;
  display: inline-block;
  text-decoration: none;
  text-align: center;
  background-color: #1a5fb4;
  color: white;
  border-radius: 5px;
  transition: all 0.3s;
  cursor: pointer;
}

.btn-small:hover {
  background-color: #0d7df7;
}

/* 平板端适配 - 2列布局 */
@media (max-width: 1024px) {
  .doctors-section {
    padding: 60px 0;
  }

  .doctors-grid {
    grid-template-columns: repeat(2, 1fr);
    gap: 25px;
  }

  .doctor-card {
    padding: 25px;
  }

  .doctor-avatar {
    width: 110px;
    height: 150px;
  }
}

/* 移动端适配 - 单列布局 */
@media (max-width: 768px) {
  .doctors-section {
    padding: 50px 0;
  }

  .container {
    padding: 0 15px;
  }

  .section-header {
    margin-bottom: 40px;
  }

  .section-header h2 {
    font-size: 2rem;
  }

  .section-header p {
    font-size: 1rem;
  }

  .doctors-grid {
    grid-template-columns: 1fr;
    gap: 20px;
  }

  .doctor-card {
    padding: 20px;
  }

  .doctor-avatar {
    width: 100px;
    height: 130px;
    margin-bottom: 15px;
  }

  .doctor-card h3 {
    font-size: 1.1rem;
    margin-bottom: 8px;
  }

  .doctor-title {
    font-size: 0.9rem;
  }

  .doctor-specialty {
    font-size: 0.85rem;
    margin-bottom: 15px;
  }

  .btn-small {
    width: 100%;
    padding: 10px 20px;
  }
}

/* 超小屏幕适配 */
@media (max-width: 480px) {
  .doctors-section {
    padding: 40px 0;
  }

  .container {
    padding: 0 10px;
  }

  .section-header h2 {
    font-size: 1.6rem;
  }

  .doctor-card {
    padding: 18px;
  }

  .doctor-avatar {
    width: 90px;
    height: 120px;
    
  }
}
</style>
